import { render } from "./VitrineModal.vue?vue&type=template&id=9d31746e&scoped=true"
import script from "./VitrineModal.vue?vue&type=script&lang=js"
export * from "./VitrineModal.vue?vue&type=script&lang=js"

import "./VitrineModal.vue?vue&type=style&index=0&id=9d31746e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d31746e"]])

export default __exports__